export const Selectors = {
	BOOKING_DATEPICKER: '#ig-trialbooking-picker',
	CLUB_SELECTOR: '#club-selection',
	DATEPICKER: '.datepicker',
	DATEPICKER_DAYS: '.datepicker-days',
	APPOINTMENTS: '.appointments',
	BOOKING_FORM: '#booking-form',
	BOOKING_DATE_INPUT: '#booking-date-input',
	BOOKING_DATE_END_INPUT: '#booking-date-end-input',
	BOOKING_EMPLOYEE_ID_INPUT: '#booking-employee-id-input',
	BOOKING_CALENDAR_ID_INPUT: '#booking-calendar-id-input',
	TRAINER_APPOINTMENT_RADIO_0: '#trainerAppointment0',
	TRAINER_APPOINTMENT_RADIO_1: '#trainerAppointment1',
	BOOKING_GUEST: '#newBooking-guest',
	BOOKING_GUESTNAME: '#newBooking-guestname',
	BOOKING_GUESTPHONE: '#newBooking-guestphone'
};

export const Settings = {
	AJAX_TYPE_NUM: 4200
};

export const PluginNames = {
	4200: 'tx_igtrialbooking_booking',
	4300: 'tx_igpromotool_promotool'
};

export const ResponseCodes = {
	// successfully created booking
	BOOKING_CREATED: 200,
	// booking date was already reserved
	BOOKING_BLOCKED: 300
};
